<h2 class="adminpanel">Admin PANEL</h2>

<aside #sidebar [ngClass]="{opened: sidebarOpened}" id="sidebar">

  <mat-nav-list>

    <app-menu-list-item *ngFor="let item of navItems" [item]="item" [modulesActives]="myActiveModules">
    </app-menu-list-item>
  </mat-nav-list>





  <div class="sidebar-item-wrapper" id="logout" (click)="modalExit()">
    <div class="sidebar-item">
      <i class="text-white material-icons">exit_to_app</i>
      <span class="text-white text-uppercase" translate="menu.logout"></span>

    </div>
  </div>


</aside>


<div id="sidebar-movesion-logo">
  <img src="assets/img/movesion_logo_login.svg" alt="movesion" />
</div>
